import { Component, h, Host, JSX } from '@stencil/core';

/**
 * @slot - Contents placed within the element
 */
@Component({
  tag: 'wb-visually-hidden',
  styleUrl: 'visually-hidden.scss',
  shadow: true,
})
export class VisuallyHidden {
  public render(): JSX.Element {
    return (
      <Host class="wb-visually-hidden">
        <slot />
      </Host>
    );
  }
}
